import { useNaptime } from 'bundles/naptimejs';
import SubscriptionsV1 from 'bundles/naptimejs/resources/subscriptions.v1';

// TODO: migrate to useQuery
const useSubscriptions = (): SubscriptionsV1[] => {
  const {
    data: { subscriptions },
  } = useNaptime<{ subscriptions: SubscriptionsV1[] }>(() => ({
    subscriptions: SubscriptionsV1?.me({
      fields: [
        'subscriptionId',
        'cartId',
        'id',
        'isActive',
        'nextBillingAt',
        'productItemId',
        'productType',
        'status',
        'productSku',
        'paymentInformation',
        'paymentProcessorId',
      ],
    }),
  }));

  return subscriptions;
};

export default useSubscriptions;
